import ProjectCard from "./ProjectCard";
import Container from "react-bootstrap/Container";
import projects from "../data/projects.json";

function ProjectSection() {
  return (
    <Container>
      <section className="pt-5" id="projects">
        <h2 className="mb-4 border-bottom">Projects</h2>

        <div className="d-flex flex-wrap gap-lg-3 gap-4">
          {
            Object.values(projects).map((project, index) =>
              <ProjectCard key={index} project={project} />
            )
          }
        </div>
      </section>
    </Container>
  );
}

export default ProjectSection;